import { times } from 'lodash-es';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import BooksSelect from '../../../../components/books/common/inputs/BooksSelect';
import BooksLabeledContainer from '../../../../components/books/model1/BooksLabeledContainer';
import BooksMenu from '../../../../components/books/model1/BooksMenu';
import * as IBooks from '../../../../interfaces/merchants/resources/books';

interface Props extends InjectedIntlProps {
  settings: IBooks.SettingEvent;
  attendees: number | undefined;
  onChangeAttendees: (n: number) => void;
  withExpressFlow: boolean;
}

class InputBookingEventDateTimeCommonHeader extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleChangeAttendees = this.handleChangeAttendees.bind(this);
  }

  public handleChangeAttendees(e: React.ChangeEvent<HTMLSelectElement>) {
    const {
      currentTarget: { value },
    } = e;
    const attendees = parseInt(value, 10);
    this.props.onChangeAttendees(attendees);
  }

  public render() {
    const {
      settings: {
        name,
        multipleAttendees: { allowed, max },
        attendeesCustomLabel,
      },
      attendees,
      withExpressFlow,
      intl,
    } = this.props;
    const attendeesTitleLabel = attendeesCustomLabel
      ? attendeesCustomLabel
      : intl.formatMessage({
          id: 'books.formsLabel.numberOfPeopleToBook',
        });
    const attendeesNum = (n: number) =>
      attendeesCustomLabel ? `${n}` : `${n}人`;
    return (
      <div>
        {!withExpressFlow && (
          <BooksLabeledContainer
            label={intl.formatMessage({
              id: 'books.formsLabel.selectedBooks',
            })}
            paddingTop={true}
            contentsPadding={true}
          >
            <BooksMenu menuName={name} />
          </BooksLabeledContainer>
        )}
        <div>
          {allowed && (
            <BooksLabeledContainer
              label={attendeesTitleLabel}
              paddingTop={true}
            >
              <BooksSelect
                name="attendees"
                value={attendees}
                onChange={this.handleChangeAttendees}
                selected={attendees !== undefined}
              >
                {times(max).map(n => (
                  <option key={n} value={n + 1}>
                    {attendeesNum(n + 1)}
                  </option>
                ))}
              </BooksSelect>
            </BooksLabeledContainer>
          )}
        </div>
      </div>
    );
  }
}

export default injectIntl(InputBookingEventDateTimeCommonHeader);
